import { API } from '@config';
import { StandardsAndGuidelinesResidentTable } from '@src/types/StandardsAndGuidelinesResidential';

export const getStandardsAndGuidelinesResident = async () => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${API}/api/residential-fn-p-standards?populate=File&sort=id%3Adesc`, options);
  const data: StandardsAndGuidelinesResidentTable = await response.json();

  return data;
};
